const i = (e = 0) => new Promise((t) => {
  let r = o(t);
  ["click", "mousemove", "scroll", "keypress", "resize", "touchstart", "touchmove"].forEach((s) => {
    document.addEventListener(s, () => {
      r = c(r, t);
    });
  });
}), c = (e, t) => (window.clearTimeout(e), o(t)), o = (e) => setTimeout(() => {
  e(!0);
}, 2e4);
export {
  i as default
};
